export function TagPlusFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.828 3a3 3 0 00-2.12.879l-1.83 1.828A3 3 0 003 7.828v2.47a3 3 0 00.657 1.874l6.166 7.708a3.001 3.001 0 003.528.883 6 6 0 007.57-9.304 2.982 2.982 0 00-1.041-1.636l-7.707-6.166A3 3 0 0010.297 3h-2.47zM9 11a2 2 0 100-4 2 2 0 000 4zm8 1a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 011-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
